import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class Rooms {
    static getroom() {
        return axios
            .get(API_PATHS.getRooms)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static postaddroom(item) {
        return axios
            .post(API_PATHS.postroom,
                item
            )
            .then((response) => {
                if (response.data) {
                    //localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }


    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default Rooms;